






































import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';
import MemberOrderResponseModel from '@/models/member/MemberOrderResponseModel';

@Component({
        name: 'MemberOrders',
    },
)
export default class MemberOrders extends ViewBase {

    public orders: MemberOrderResponseModel[] = [];

    public headers = [
        {text: 'Order ID', align: 'left', sortable: true, value: 'orderId'},
        {text: 'Date/Time', align: 'left', sortable: true, value: 'createdDateTimeUtc'},
        {text: 'Product', align: 'left', sortable: true, value: 'productName'},
        {text: 'Price', align: 'left', sortable: true, value: 'price'},
        {text: 'Quantity', align: 'left', sortable: true, value: 'quantity'},
        {text: 'Total', align: 'left', sortable: true, value: 'total'},
    ];

    public get showOrders(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public async created() {
        try {
            this.resetInitializationValues();

            const api = new MemberApi();
            this.orders = await api.getOrdersAsync(this.$store.state.member.jwt);
        }
        catch ( err ) {
            await this.handleInitializationErrorAsync(err);
        }
        finally {
            this.initializing = false;
        }
    }
}

